import React from 'react'
import AddSurgicalOrderV2Layout from 'presentation/doctor/layouts/AddSurgicalOrderV2'

function AddSurgicalOrderV2() {
  return <AddSurgicalOrderV2Layout />
}

export default AddSurgicalOrderV2
